import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeviceStatusSchema } from './shapes';

export const ImeiSearchQuerySchema = z.object({
  imei: z.string().trim().min(1),
});

export const ImeiSearchMatchSchema = z.object({
  id: z.string().uuid(),
  imei: z.string(),
  name: z.string(),
  status: DeviceStatusSchema,
  assignedUserId: z.string().uuid().nullable(),
  assignedUserName: z.string().nullable(),
});
export type ImeiSearchMatch = z.infer<typeof ImeiSearchMatchSchema>;

export const ImeiSearchResponseSchema = z.object({
  data: z.array(ImeiSearchMatchSchema),
});

export const searchDevicesByImei = defineEndpoint({
  method: 'GET',
  path: '/v1/devices/search',
  params: z.object({}),
  query: ImeiSearchQuerySchema,
  body: z.undefined(),
  response: ImeiSearchResponseSchema,
});
